<template>
  <div>
    <v-card class="mx-auto mb-6" flat>
      <v-card-text>
        <template v-for="(kelompok, kelompokId) in kelompoks">
          <div :key="kelompokId" class="my-5">
            <div v-if="kelompok.title" class="mx-3">
              <span class="font-weight-medium indigo--text" style="font-size: 16px">{{ kelompok.title }}</span>
              <v-divider class="primary mt-1" style="height: 2.5px; max-height: 2.5px" />
            </div>
            <v-container>
              <v-list class="py-0" v-if="kelompok.model === 'table'">
                <v-list-item class="hidden-md-and-down px-0">
                  <v-row class="mt-0">
                    <v-col cols="12" lg="6" class="my-auto py-1">
                      <v-row no-gutters style="flex-wrap: nowrap">
                        <v-col
                          style="min-width: 25px; max-width: 100%"
                          class="flex-grow-0 flex-shrink-0 text-right mr-2 text-right py-1"
                        >
                          &nbsp;
                        </v-col>
                        <v-col
                          style="max-width: 100%"
                          class="flex-grow-1 flex-shrink-0 text-justify py-1 font-weight-medium"
                        >
                          Pertanyaan
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6" class="my-auto py-1">
                      <v-row>
                        <v-col
                          v-for="(opsi, opsiId) in $getDeepObj(listInstrumen, `${kelompok.key}.0.opsi`) || []"
                          :key="`${kelompokId}-XX-${opsiId}`"
                          cols="11"
                          offset="1"
                          offset-lg="0"
                          lg="3"
                          class="py-1"
                        >
                          <div class="font-weight-medium">{{ opsi.keterangan }}</div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item
                  v-for="(instrumen, instrumenId) in listInstrumen[kelompok.key] || []"
                  :key="`${kelompokId}-${instrumenId}`"
                  class="mb-2 px-0"
                >
                  <v-row :class="[instrumenId > 0 ? 'mt-3' : 'mt-0', 'mt-lg-0']">
                    <v-col cols="12" lg="6" class="my-auto">
                      <v-row no-gutters style="flex-wrap: nowrap">
                        <v-col
                          style="min-width: 25px; max-width: 100%"
                          class="flex-grow-0 flex-shrink-0 text-right mr-2 text-right"
                        >
                          {{ instrumen.nomor || instrumenId + 1 }}.
                        </v-col>
                        <v-col style="max-width: 100%" class="flex-grow-1 flex-shrink-0 text-justify">
                          {{ instrumen.keterangan }}
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" lg="6" class="py-0 py-lg-2">
                      <v-row>
                        <v-col
                          v-for="(opsi, opsiId) in instrumen.opsi || []"
                          :key="`${kelompokId}-${instrumenId}-${opsiId}`"
                          cols="11"
                          offset="1"
                          offset-lg="0"
                          lg="3"
                        >
                          <div class="hidden-lg-and-up">{{ opsi.keterangan }}</div>
                          <v-text-field
                            v-model="form[opsi.k_monev_opsi_psp]"
                            v-mask="`#####`"
                            placeholder="rekap angka"
                            outlined
                            dense
                            hide-details
                            :disabled="readOnly"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <div
                  v-for="(instrumen, instrumenId) in listInstrumen[kelompok.key] || []"
                  :key="`${kelompokId}-${instrumenId}`"
                >
                  <v-divider v-if="instrumenId !== 0" class="my-5" />
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <div class="px-0 body-2 indigo--text font-weight-medium" style="min-height: 24px">
                        {{ instrumen.keterangan || '-' }}
                      </div>
                      <v-list v-if="instrumen.tipe === 'textarea'">
                        <v-textarea
                          v-model="form[`instrumen-${instrumen.k_monev_instrumen_psp}`]"
                          placeholder="tuliskan jawaban"
                          rows="2"
                          auto-grow
                          outlined
                          hide-details
                          :disabled="readOnly"
                        />
                      </v-list>
                      <v-list class="py-0">
                        <v-list-item
                          class="px-0 mt-2 mt-lg-0"
                          v-for="(opsi, opsiId) in instrumen.opsi || []"
                          :key="`${kelompokId}-${instrumenId}-${opsiId}`"
                        >
                          <v-list-item-content>
                            <v-row>
                              <v-col cols="12" :lg="getGrid('opsi', instrumen)" class="my-auto py-0 py-lg-2">
                                {{ opsi.keterangan }}
                              </v-col>
                              <v-col cols="12" :lg="getGrid('rekap', instrumen)" class="py-1 py-lg-2">
                                <v-text-field
                                  v-model="form[opsi.k_monev_opsi_psp]"
                                  v-mask="`#####`"
                                  placeholder="Tuliskan rekap angka"
                                  outlined
                                  dense
                                  hide-details
                                  :disabled="readOnly"
                                />
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list>
            </v-container>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import schemaEvaluasiPelaksanaan from '../instrumen/EvaluasiPelaksanaan';
import schemaEvaluasiIht from '../instrumen/EvaluasiPip';
import { mapState } from 'vuex';

export default {
  name: 'FormPartisipan',
  mixins: [schemaEvaluasiPelaksanaan, schemaEvaluasiIht],
  props: {
    title: {
      type: String,
      default: '',
    },
    childId: {
      type: [String, Number],
      default: null,
    },
    initValue: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapState('iht', {
      listInstrumen: (state) => state.instrumen || {},
    }),

    kelompoks() {
      return this[this.type === 'evaluasi-pelaksanaan' ? 'schemaEvaluasiPelaksanaan' : 'schemaEvaluasiPip'];
    },
  },
  methods: {
    reset() {
      const pspMonevInstrumens = this.$getDeepObj(this.initValue, 'psp_monev_instrumens') || [];

      this.$set(this, 'form', {});
      for (const pspMonevIns of pspMonevInstrumens) {
        if (pspMonevIns.rekap !== null) {
          this.$set(this.form, pspMonevIns.k_monev_opsi_psp, pspMonevIns.rekap);
        } else {
          this.$set(this.form, `instrumen-${pspMonevIns.k_monev_instrumen_psp}`, pspMonevIns.catatan);
        }
      }
    },

    getGrid(tipe, instrumen) {
      let init = { opsi: 2, rekap: 3 };
      if ([201, 262, 302, 303, 304, 305, 306, 307, 308, 309].includes(+instrumen.k_monev_instrumen_psp)) {
        init = { opsi: 6, rekap: 3 };
      }

      return init[tipe];
    },

    getValue() {
      let values = Object.assign({}, this.form);
      let result = [];
      let resultKelompok = [];

      for (const kelompok of this.kelompoks) {
        for (const instrumen of this.listInstrumen[kelompok.key]) {
          if (instrumen.opsi) {
            for (const opsi of instrumen.opsi) {
              if (values[opsi.k_monev_opsi_psp]) {
                result.push({
                  k_monev_instrumen_psp: instrumen.k_monev_instrumen_psp,
                  k_monev_opsi_psp: opsi.k_monev_opsi_psp,
                  rekap: values[opsi.k_monev_opsi_psp] || 0,
                });

                if (!resultKelompok.includes(kelompok.key)) {
                  resultKelompok.push(kelompok.key);
                }
              }
            }
          } else {
            if (values[`instrumen-${instrumen.k_monev_instrumen_psp}`]) {
              result.push({
                k_monev_instrumen_psp: instrumen.k_monev_instrumen_psp,
                catatan: values[`instrumen-${instrumen.k_monev_instrumen_psp}`],
              });

              if (!resultKelompok.includes(kelompok.key)) {
                resultKelompok.push(kelompok.key);
              }
            }
          }
        }
      }

      return { instrumens: result, kelompok: resultKelompok.join('|') };
    },
  },
};
</script>

<style scoped></style>
